import Spinner from "../../../../../components/layout/Spinner";
import { useTranslation } from "react-i18next";
import {
  getDetails,
} from "../../../../../actions/admin/quotation";
import { pdf } from "@react-pdf/renderer";
import QuotationDocument from "../../../../../components/admin/quotation/_components/pdf/QuotationDocument";
import { saveAs } from 'file-saver';
import { EyeIcon, DownloadNarrowIcon } from "../../../../../components/icons";

const Receipts = ({
  loading,
  customerQuotations
}) => {
  const { t } = useTranslation();

  const downloadButtonClickFunc = async (quotationId) => {
    var res = await getDetails(quotationId);
    if (res.bookings.length > 0 && res.quotationStatus !== "DRAFT") {

      const blob = await pdf((
        <QuotationDocument data={res} />
      )).toBlob();

      saveAs(blob, `TLF-RECEIPTS-${res?.quotationID}.pdf`);

    }
  };

  return (
    <>
      <div className="tw:md:mx-4 tw:mt-2">
        {/* DESKTOP VIEW */}
        <div className="tw:block tw:w-full tw:overflow-x-auto tw:hidden tw:md:block tw:mt-6">
          <table className="tw:w-full tw:mb-4 tw:align-top tw:border-collapse tw:text-[#212529]">
            <thead>
              <tr>
                <th scope="col">Date</th>
                <th scope="col">Receipt ID</th>
                <th scope="col">Title</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {
                loading ? (
                  <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:text-center" >
                    <Spinner />
                  </div>
                ) : customerQuotations?.recordsFiltered > 0 ? (
                  customerQuotations?.data?.map((q, i = 0) => (
                    <tr>
                      <td className="td-table-myPage">{q.date}</td>
                      <td className="td-table-myPage">{q.quotationID}</td>
                      <td className="td-table-myPage">{q.quotationNumber}</td>
                      <td className="td-table-myPage">
                        <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:justify-center">
                          <div className="tw:px-[calc(var(--gx)/2)] tw:w-[41.6667%] tw:flex-none tw:grid">
                            <button
                              type="button"
                              className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none bg-gold-light-100 tw:rounded-[0.375rem]"
                            >
                              <EyeIcon color="#DBBE78" size={18} />
                              &nbsp; View
                            </button>
                          </div>
                          <div className="tw:px-[calc(var(--gx)/2)] tw:w-[58.3333%] tw:flex-none tw:grid">
                            <button
                              type="button"
                              className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none tw:bg-[#d4b055] tw:border-[#d4b055] tw:text-[#4a4a4a] tw:hover:bg-[#c2a86b] tw:hover:border-[#c2a86b] tw:hover:opacity-60 tw:rounded-[0.375rem]"
                              onClick={() => downloadButtonClickFunc(q._id)}
                            >
                              <DownloadNarrowIcon color="#FFFFFF" />
                              &nbsp; <span className="white-text">Download</span>
                            </button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4}>
                      <div className="tw:flex tw:justify-center tw:items-center tw:py-12 tw:mt-4 tw:mb-12">
                        <p className="tw:m-0">{t('myPage.booking.bookingItem.noBooking')}</p>
                      </div>
                    </td>
                  </tr>
                )
              }
            </tbody>
          </table>
        </div>

        {/* MOBILE VIEW */}
        <div className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] tw:mb-4 tw:block tw:md:hidden">
          <div className="tw:flex-1 tw:p-4">
            <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:justify-between tw:items-center tw:mb-4">
              <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow fs-14">2023/07/31</div>
            </div>
            <p className="fs-16 noto">TLF July Invoice</p>
            <p>
              <b>Receipt ID : </b>24F3BF790
            </p>
            <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:p-0">
              <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none">
                <button type="button" className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none bg-gold-light-100 tw:rounded-[0.375rem]">
                  <EyeIcon color="#DBBE78" size={18} />
                  &nbsp; View
                </button>
              </div>
              <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:p-0">
                <button type="button" className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none tw:bg-[#d4b055] tw:border-[#d4b055] tw:text-[#4a4a4a] tw:hover:bg-[#c2a86b] tw:hover:border-[#c2a86b] tw:hover:opacity-60 tw:rounded-[0.375rem]">
                  <DownloadNarrowIcon color="#FFFFFF" />
                  &nbsp; <span className="white-text">Download</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Receipts;
